export enum AffiliateStatus {
    new = 'new',
    generated = 'generated',
    waitToPublish = 'wait-to-publish',
    published = 'published',
    invalid = 'invalid',
    error = 'error'
}